import React from 'react';
import PropTypes from 'prop-types';
// import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import InsideHeader from '../../components/InsideHeader';
import PageWrapper from '../../components/PageWrapper';
import MenuFind from '../../components/MenuFind';
import FooterForm from '../../components/FooterForm';
import HomesResults from './HomesResults';

const styles = css``;

export const sortOptions = [
  { title: 'City', field: 'address.addressLocality', dir: 'asc' },
];

class Homes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
      showMap: false,
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }

  render() {
    const { page } = this.props;
    const { sort } = this.state;

    return (
      <PageWrapper className={styles}>
        <PageHelmet page={page} />
        <InsideHeader h1={`${page.page_title[0].title}`} h1Pre={`${page.page_title[0].pretitle}`} leadText={`${page.lead_copy}`} />
        <MenuFind />
        <HomesResults sort={sort} />
        <FooterForm />
      </PageWrapper>
    );
  }
}

Homes.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'available_now',
})(Homes);



// WEBPACK FOOTER //
// ./src/pages/Homes/index.js